import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    listPaper: {
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.secondary.main,
        border: "solid 1px",
        borderRadius: 20,
        boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.4)",
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        paddingLeft: 5,
        paddingRight: 5
    },
    listHeader: {
        ...theme.typography.body1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    numberDescriptionContainer: {
        // https://stackoverflow.com/questions/2997767/how-do-i-keep-two-side-by-side-div-elements-the-same-height
        display: 'flex',
        flex: 1,

        flexDirection: 'column',
        padding: 5
    },
    description: {
        ...theme.typography.subtitle2,
        textAlign: 'center'
    },
    number: {
        ...theme.typography.h3,
        textAlign: 'center',
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'start'
    },
    secondaryNumberIconRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'start'
    },
    divider: {
        width: "100%"
    }
}));

export {useStyles};